import { matchPath } from 'react-router-dom';

export interface AppShellBreadcrumb {
  label: string;
  path?: string;
}

/**
 * Build breadcrumb trail from a pathname (pure; used by the route hook).
 * @param {string} pathname
 * @returns {AppShellBreadcrumb[]}
 */
export function buildAppShellBreadcrumbs(pathname: string): AppShellBreadcrumb[] {
  if (pathname === '/home') {
    return [{ label: 'Home' }];
  }

  if (pathname === '/agents') {
    return [{ label: 'Home', path: '/home' }, { label: 'Agents' }];
  }

  const agentMatch = matchPath({ path: '/agents/:id', end: true }, pathname);
  if (agentMatch?.params.id) {
    return [
      { label: 'Home', path: '/home' },
      { label: 'Agents', path: '/agents' },
      { label: `Agent ${agentMatch.params.id}` },
    ];
  }

  if (pathname === '/settings') {
    return [{ label: 'Home', path: '/home' }, { label: 'Settings' }];
  }

  if (pathname.startsWith('/design-system')) {
    return [
      { label: 'Home', path: '/home' },
      { label: 'Settings', path: '/settings' },
      { label: 'Design system' },
    ];
  }

  return [{ label: 'Home', path: '/home' }];
}
